var render = function render(){var _vm=this,_c=_vm._self._c;return _c('FrField',{attrs:{"label":"Bucket Search","field":_vm.field,"type":"multiselect"},on:{"search-change":_vm.handleSearch},scopedSlots:_vm._u([{key:"option",fn:function({ option }){return [_vm._v(" "+_vm._s(option.text)+" ")]}},{key:"singleLabel",fn:function({ option }){return [_vm._v(" "+_vm._s(option.text)+" ")]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }